import { SessionStoreProvider } from '@batiflow/client-core/react';
import { useEffect, type ReactNode } from 'react';
import { isPublicPath } from '../public-paths';
import { useRuntime } from './runtime-provider';

/**
 * client-core session store: loads GET /me once, then exposes the session to the tree. A public
 * page (a quote link, `/q/{token}`) has no session: nothing is loaded for it.
 */
export function SessionProvider({ children }: { children?: ReactNode }) {
  const { sessionStore, navigation } = useRuntime();

  useEffect(() => {
    if (isPublicPath(navigation.currentPath())) return;
    if (sessionStore.getState().status === 'idle') void sessionStore.getState().bootstrap();
  }, [sessionStore, navigation]);

  return <SessionStoreProvider store={sessionStore}>{children}</SessionStoreProvider>;
}
